export default "__VITE_ASSET__CCAMxyrn__"